<template>
  <v-navigation-drawer v-if="show" v-model="drawerVal" fixed app>
    <v-list dense>


        <v-list-tile
          v-for="(link, i) in linksToShow"
          :key="i"
          :to="link.to"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="link.text"
          />
        </v-list-tile>



    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      links: [
          {
              to: '/',
              icon: 'fas fa-trophy',
              text: 'Competitions'
          },
          {
              to: '/natorgs',
              icon: 'fas fa-building',
              text: 'National Organizations'
          },
          {
              to: '/invite',
              icon: 'fas fa-mail-bulk',
              text: 'Invite New Users'
          },
          {
              to: '/addtocomp',
              icon: 'fas fa-user-plus',
              text: 'Add Existing Users to Competitions'
          },
      ]
    };
  },
  created() {
    
  },
  computed: {
    ...mapGetters(["isAdmin", "isNorgAdmin", "drawer", "noidContext"]),
    show() {
      return this.isAdmin || this.isNorgAdmin
    },
    linksToShow() {
      if (this.isAdmin) {
        return this.links
      }
      if (this.isNorgAdmin) {
        // eslint-disable-next-line 
        this.links[2].to = '/invite/'+this.noidContext
        // eslint-disable-next-line 
        this.links[3].to = '/addtocomp/'+this.noidContext
        return [this.links[0], this.links[2], this.links[3]]
      }
      return []
    },
    drawerVal: {
      get() {
        return this.drawer;
      },
      set(val) {
        this.$store.commit("setDrawer", val);
      }
    }
  }
};
</script>

